import {Component,Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {ListeNoireHttpService} from "@services/admin/parametre/authentification/liste-noire-http.service";
import {handleResult} from "@share/utils/handle-result";

/**
 * Composant pour l'ajout d'un mot de passe à la liste noire
 *
 * @author Lionel Gimenez
 * @date 26/08/2025
 */
@Component({
    host: {'data-test-id': 'liste-noire-add'},
    templateUrl: './liste-noire-add.component.html'
})
export class ListeNoireAddComponent {
    /** Mot de passe à interdire */
    motDePasse: string;

    /** Fichier dictionnaire */
    fichier: File;

    /** Enregistrement en cours */
    isSaving: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        private translateService: TranslateService,
        private toastrService: ToastrService,
        private matDialogRef: MatDialogRef<ListeNoireAddComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private listeNoireHttpService: ListeNoireHttpService
    ) {
    }

    /**
     * Gestion du changement de fichier
     */
    onFileChange(event: any): void {
        if (event.target.files && event.target.files.length) {
            this.fichier = event.target.files[0];
        }
    }

    /**
     * Handler pour l'enregistrement
     */
    onSave(): void {
        //Début de l'enregistrement
        this.isSaving = true;

        this.listeNoireHttpService.save(this.motDePasse,this.fichier)
            .pipe(handleResult(this.translateService,this.toastrService))
            .subscribe(result => {
                //Si tout s'est bien passé
                if (result != null) {
                    //On ferme
                    this.matDialogRef.close(true);
                }
            });
    }

    /**
     * Indique si la sauvegarde est désactivée
     */
    isSaveDisabled(): boolean {
        return (!this.motDePasse && !this.fichier) || this.isSaving;
    }
}
